<template>
    <validation-observer ref="linksObserver">
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" v-if="alertVisible">
                    <v-alert type="info" class="mb-0 body-2" v-show="!data.id" dismissible @click="alertClosed">
                        You must save the project before you can use the entry test link
                    </v-alert>
                </v-col>

                <v-col cols="12" lg="12">

                    <!-- ENTRY LINK -->
                    <title-card-list title="Entry link"
                                     help="edit-project-links-entry-link"
                                     side-icon="mdi-location-enter">

                        <!-- ENTRY ERROR -->
                        <v-list-item v-show="errorMessages.entry_link && !data.entry_link">
                            <v-list-item-content>

                                <v-alert class="body-2" type="error">
                                    Entry link must be configured
                                </v-alert>

                            </v-list-item-content>
                        </v-list-item>

                        <!-- ENTRY LINK NAME -->
                        <v-list-item v-show="data.entry_link" class="pt-0">
                            <v-list-item-content class="pb-1">
                                <v-text-field
                                    v-if="data.entry_link"
                                    class="mt-0 body-2"
                                    v-model="data.entry_link.name"
                                    disabled
                                    label="Template name"
                                    hide-details
                                ></v-text-field>
                            </v-list-item-content>

                        </v-list-item>

                        <!-- ENTRY LINK EXAMPLE -->
                        <v-list-item v-show="data.entry_link">
                            <v-list-item-content class="pb-1 pt-0">
                                <v-text-field
                                    v-if="data.entry_link"
                                    class="mt-0 body-2"
                                    v-model="data.entry_link.example_url"
                                    disabled
                                    label="Project entry link"
                                    hide-details
                                ></v-text-field>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-tooltip color="primary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab
                                               small
                                               v-on="on"
                                               :disabled="!saved"
                                               @click="testEntryLinkClicked()"
                                               class="elevation-0 mb-3"
                                               color="primary">
                                            <v-icon>mdi-link</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Test link</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </v-list-item>

                        <!-- ENTRY LINK ACTION BUTTONS -->
                        <v-list-item class="pt-0">
                            <v-btn v-show="data.entry_link" small @click="editLinkDialogModel=true" color="primary">
                                Configure
                            </v-btn>

                            <v-btn small class="ml-2" @click="linkManagerModel=true" color="primary">
                                Select from template
                            </v-btn>
                        </v-list-item>

                        <!-- LINK MANAGER -->
                        <links-manager v-model="linkManagerModel"
                                       @use="useEntryLink"
                        ></links-manager>

                        <!-- EDIT LINk DIALOG -->
                        <edit-link-dialog v-if="data.entry_link.name"
                                          v-model="editLinkDialogModel"
                                          :link="data.entry_link"
                                          :edit-template="false"
                                          :data-variables="dataVariables"
                                          @use="useEntryLink"
                        ></edit-link-dialog>

                    </title-card-list>
                </v-col>

                <!-- EXIT LINKS -->

                <v-col cols="12" lg="12">

                    <title-card-list title="Exit links"
                                     help="edit-project-links-exit-links"
                                     side-icon="mdi-location-exit">

                        <!-- TEST LINK COMPLETE -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">
                                <v-text-field
                                    :disabled="true"
                                    class="body-2"
                                    v-model="data.exit_link_complete"
                                    label="Completes"
                                    hide-details
                                    @change="surveyLinkUpdated"
                                ></v-text-field>
                            </v-list-item-content>

                        </v-list-item>

                        <!-- TEST LINK PROFILE -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">
                                <v-text-field
                                    :disabled="true"
                                    class="body-2"
                                    v-model="data.exit_link_profile"
                                    label="Profile terminated"
                                    hide-details
                                    @change="surveyLinkUpdated"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>

                        <!-- TEST LINK QUOTA -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">
                                <v-text-field
                                    :disabled="true"
                                    class="body-2"
                                    v-model="data.exit_link_quota"
                                    hide-details
                                    label="Quota terminated"
                                    @change="surveyLinkUpdated"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>

                        <!-- TEST LINK DUPLICATE -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">
                                <v-text-field
                                    :disabled="true"
                                    class="body-2"
                                    v-model="data.exit_link_duplicate"
                                    hide-details
                                    label="Duplicate terminated"
                                    @change="surveyLinkUpdated"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>

                        <!-- TEST LINK QUALITY -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">
                                <v-text-field
                                    :disabled="true"
                                    class="body-2"
                                    v-model="data.exit_link_quality"
                                    hide-details
                                    label="Quality terminated"
                                    @change="surveyLinkUpdated"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>

                        <!-- EXIT HASH ALGORITHM -->
                        <v-list-item>
                            <v-list-item-content class="pt-0">

                                <div class="d-flex">

                                    <v-select
                                        style="max-width: 300px;"
                                        :items="exitAlgorithms"
                                        v-model="data.exit_link_algorithm"
                                        label="Hash algorithm"
                                        :error-messages="errorMessages.exit_link_algorithm ? errorMessages.exit_link_algorithm : null"
                                        hide-details
                                        @change="updateEntryExitLinks(true)"
                                    ></v-select>

                                    <v-text-field
                                        v-show="data.exit_link_algorithm !== 'None'"
                                        style="max-width: 300px;"
                                        class="body-2 ml-2"
                                        v-model="data.exit_link_secret"
                                        label="Hash secret"
                                        @change="updateEntryExitLinks(true)"
                                        hide-details
                                        :error-messages="errorMessages.exit_link_secret ? errorMessages.exit_link_secret : null"
                                    ></v-text-field>
                                </div>
                            </v-list-item-content>
                        </v-list-item>

                    </title-card-list>
                </v-col>
            </v-row>

            <!-- TEST LINK CONFIG DIALOG -->
            <test-link-dialog v-model="testLinkDialogModel" :project="project"></test-link-dialog>

            <json v-if="false" :data="data"/>

        </v-container>
    </validation-observer>

</template>

<script>

import Json from 'vue-json-pretty';
import TitleCard from "../../../../../components/UI/TitleCard";
import {extend} from 'vee-validate/dist/vee-validate.full';
import TitleCardList from "../../../../../components/UI/TitleCardList";
import LinksManager from "../../../../LinksManager/components/LinksManager";
import EditLinkDialog from "../../../../LinksManager/components/EditLinkDialog";
import EditLink from "../../../../LinksManager/components/EditLinkDialog";
import ExampleLinkBuilder from "../../../../LinksManager/ts/ExampleLinkBuilder";
import ToolbarPage from "../../../../../components/UI/ToolbarPage";
import TestLinkDialog from "../TestLinkDialog";

export default {

    components: {
        TestLinkDialog,
        ToolbarPage,
        EditLink,
        Json,
        TitleCard,
        TitleCardList,
        LinksManager,
        EditLinkDialog
    },

    props: {
        project: {
            required: true,
            type: Object | null,
        },
        dataVariables: {
            required: true,
            type: Array
        },
        errorMessages: {
            required: false,
            type: Object,
            default: () => {
                return {}
            }
        },
        saved: {
            required: true,
            type: Boolean,
        }
    },

    data() {
        return {
            debug: false,
            exitAlgorithms: ['None', 'SHA256', 'SHA1', 'MD5'],

            data: {
                exit_link_algorithm: 'None',
                exit_link_secret: '!Secret!',
                exit_link_complete: 'https://' + new URL(window.location.href).hostname + '/p/exit?s=c&id=[id]&hash=[hash]',
                exit_link_profile: 'https://' + new URL(window.location.href).hostname + '/p/exit?s=p&id=[id]&hash=[hash]',
                exit_link_quota: 'https://' + new URL(window.location.href).hostname + '/p/exit?s=q&id=[id]&hash=[hash]',
                exit_link_quality: 'https://' + new URL(window.location.href).hostname + '/p/exit?s=qua&id=[id]&hash=[hash]',
                exit_link_duplicate: 'https://' + new URL(window.location.href).hostname + '/p/exit?s=dup&id=[id]&hash=[hash]',
                entry_link: {
                    id: null,
                    example_url: 'https://' + new URL(window.location.href).hostname + '/p/survey?p=[PROJECT_ID]&id=[value]&hash=[value]',
                    base_url: 'https://' + new URL(window.location.href).hostname + '/p/survey?p=[PROJECT_ID]',
                    name: 'Sample Ninja Test Survey',
                    hash_algo: 'SHA256',
                    hash_param: 'hash',
                    hash_secret: '!Secret!',
                    params: [],
                    pid_param: 'id'
                }
            },
            linkManagerModel: false,
            editLinkDialogModel: false,
            entryLinkSet: false,
            testLinkDialogModel: false,
        }
    },

    created() {

        extend('url', {
            validate(value) {
                return new RegExp('^https:\/\/[0-9-a-z]+[^?/]', 'i').test(value);
            },
            message: "Valid URL is required and must begin with https://"
        });
    },

    watch: {
        errorMessages(errors) {
            if (errors.entry_link || errors.exit_link_algorithm || errors.exit_link_secret) {
                this.$emit('error', {name: 'tab4', error: true});
            }
        },
        project(project) {
            if (project) {
               this.updateEntryExitLinks();
            }
        },
    },

    computed: {

        alertVisible() {
            return !localStorage.getItem('editProjectLinksInfoAlert');
        }
    },

    methods: {

        alertClosed() {
            localStorage.setItem('editProjectLinksInfoAlert', JSON.stringify(false));
        },

        useEntryLink(data) {

            this.entryLinkSet = false;
            this.data.entry_link = Object.assign(this.data.entry_link, data);
            this.updateEntryExitLinks();
            this.$emit('error', {name: 'tab4', error: false});
            this.emit();
        },

        surveyLinkUpdated(link) {

            if (link.indexOf("[id]") === -1) {
                Bus.$emit('flash-message', {type: 'error', message: 'Project link must pass on [id] variable!'});
            }

            this.emit();
        },

        updateEntryExitLinks(force = false) {

            if (!this.entryLinkSet || force) {

                this.entryLinkSet = true;

                if (!this.entryLinkSet) {
                    this.data.exit_link_algorithm = !this.project.exit_link_algorithm ? 'None' : this.project.exit_link_algorithm;
                    this.data.exit_link_secret = !this.project.exit_link_secret ? '!SecretSalt!' : this.project.exit_link_secret;
                }

                if (this.project.entry_link) {
                    this.data.entry_link = Object.assign({}, this.data.entry_link, this.project.entry_link);
                }

                const linkBase = window.location.origin + '/p/exit';

                let hash = '';

                if (this.data.exit_link_algorithm !== 'None') {
                    hash = '&hash=[hash]';
                }

                this.data.exit_link_complete = linkBase + '?s=c' + hash;
                this.data.exit_link_profile = linkBase + '?s=p' + hash;
                this.data.exit_link_quota = linkBase + '?s=q' + hash;
                this.data.exit_link_quality = linkBase + '?s=qua' + hash;
                this.data.exit_link_duplicate = linkBase + '?s=dup' + hash;

                this.data.entry_link.example_url = new ExampleLinkBuilder(this.data.entry_link).get();

                this.emit();
            }
        },

        testEntryLinkClicked() {
            this.testLinkDialogModel = true;
        },

        async emit() {

            if (this.$refs.linksObserver) {

                const isValid = await this.$refs.linksObserver.validate();

                if (isValid) {
                    this.$emit('change', this.data);
                    this.$emit('error', {name: 'tab4', error: false});
                } else {
                    this.$emit('error', {name: 'tab4', error: true});
                }
            }
        }
    },

    mounted() {

        if (this.project.id) {
             this.updateEntryExitLinks();
        } else {
            this.emit();
        }
    }
}
</script>
